export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-time-line',
      title: '效率提升 10 倍',
      description: '自动化数据采集和报表生成，原本需要数周的工作现在只需几小时完成',
      gradient: 'from-blue-500 to-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '成本节省 70%',
      description: '减少人工核算成本，避免因数据错误导致的税收损失，显著降低管理成本',
      gradient: 'from-teal-500 to-teal-600',
      bgColor: 'bg-teal-50'
    },
    {
      icon: 'ri-shield-check-line',
      title: '合规率 100%',
      description: '严格按照国家政策要求设计，确保研发费用核算和申报完全符合法规要求',
      gradient: 'from-green-500 to-green-600',
      bgColor: 'bg-green-50'
    },
    {
      icon: 'ri-line-chart-line',
      title: '数据准确性 99.9%',
      description: '智能校验机制和多重审核流程，确保研发费用数据的准确性和可靠性',
      gradient: 'from-purple-500 to-purple-600',
      bgColor: 'bg-purple-50'
    }
  ];

  return (
    <section id="benefits" className="py-16 lg:py-20 bg-gradient-to-b from-white via-gray-50 to-white relative overflow-hidden">
      {/* 装饰性背景 */}
      <div className="absolute top-20 left-10 w-96 h-96 bg-teal-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse" style={{ animationDelay: '2s' }}></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center bg-gradient-to-r from-teal-50 to-blue-50 text-teal-700 px-5 py-2.5 rounded-full text-sm font-semibold mb-5 border border-teal-100 shadow-sm">
            <i className="ri-medal-line mr-2"></i>
            核心优势
          </div>
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-5">
            为什么选择
            <span className="block mt-2 bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent">
              智研云
            </span>
          </h3>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            用数据说话，用结果证明，我们致力于为企业创造真实可见的价值
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-14">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="relative bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 group cursor-pointer overflow-hidden"
            >
              {/* 悬停渐变背景 */}
              <div className={`absolute inset-0 bg-gradient-to-br ${benefit.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
              
              <div className="relative z-10 text-center">
                <div className={`w-20 h-20 flex items-center justify-center bg-gradient-to-br ${benefit.gradient} text-white rounded-2xl mx-auto mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg`}>
                  <i className={`${benefit.icon} text-3xl`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-teal-700 transition-colors">
                  {benefit.title}
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>

              {/* 装饰性角标 */}
              <div className={`absolute -bottom-2 -right-2 w-24 h-24 bg-gradient-to-br ${benefit.gradient} opacity-0 group-hover:opacity-10 rounded-full blur-2xl transition-opacity duration-500`}></div>
            </div>
          ))}
        </div>

        <div className="relative bg-gradient-to-r from-teal-600 via-teal-700 to-blue-600 rounded-3xl p-12 lg:p-16 text-white shadow-2xl overflow-hidden">
          {/* 装饰性背景图案 */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
          
          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-3 gap-12 text-center">
            <div className="group cursor-pointer">
              <div className="text-6xl font-bold mb-3 group-hover:scale-110 transition-transform">5000+</div>
              <div className="text-teal-100 text-lg font-medium">服务企业数量</div>
              <div className="w-20 h-1 bg-white/30 mx-auto mt-4 group-hover:w-32 transition-all"></div>
            </div>
            <div className="group cursor-pointer">
              <div className="text-6xl font-bold mb-3 group-hover:scale-110 transition-transform">50亿+</div>
              <div className="text-teal-100 text-lg font-medium">累计管理研发费用</div>
              <div className="w-20 h-1 bg-white/30 mx-auto mt-4 group-hover:w-32 transition-all"></div>
            </div>
            <div className="group cursor-pointer">
              <div className="text-6xl font-bold mb-3 group-hover:scale-110 transition-transform">98%</div>
              <div className="text-teal-100 text-lg font-medium">客户满意度</div>
              <div className="w-20 h-1 bg-white/30 mx-auto mt-4 group-hover:w-32 transition-all"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
